import React, { Component } from 'react';
import { Link } from "react-router-dom";
import './navigation.css';

class Navigation extends Component {
  constructor() {
    super();

    this.state = {
      menuItems: [{
        text: 'Home',
        route: '/'
      }, {
        text: 'Resume',
        href: 'https://resume.kyliexie.com'
      }]
    }
  }

  render() {
    return (
      <div className="navigation__container">
        <ul className="navigation__menu">
          {
            this.state.menuItems.map(item => (
              <li className="navigation__item">
                { item.href ? 
                  <a href={item.href} target="_blank">{item.text}</a> :
                  <Link to={item.route}>{item.text}</Link>
                }
              </li>)
            )
          }
        </ul>
      </div>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js